import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { useModules } from "../../utils/modules";
import AppTour from '../../appTour';
import Toast from '../../components/Toast';
import { getWorkkardDetailMasterData, setActivityId,startTourAction,getUserTourStatusAction, resolutionBasedClass, toggleView,
  fetchMiddlePanelNotesData, fetchMiddlePanelFilesData, resetMiddlePanel, fetchMiddlePanelDiariesData, fetchMiddlePanelPartiesData, 
  fetchMiddlePanelLogsData, fetchMiddlePanelData, hidePopupToast,setPanelVisibility,resetWorkkardDetail,getActivityDetail } from "../../containers/WorkkardDetail/actions/action";
import Icon from '../../icons';
import { hideTooltip, hideToast } from '../SpockViewPage/actions/action';

import LeftPanelContainer from "./LeftPanelContainer";
import RightPanelContainer from "./RightPanelContainer";
import MiddlePanelContainer from "./MiddlePanelContainer";
import NotePanelContainer from "./NotePanelContainer";
import ExternalAppContainer from './ExternalAppContainer';
import PopoverToast from "../../components/PopoverToast";
import { showDialogueBox } from '../../components/DialogueBox/actions';
import { WORKKARD_ID, IMAGE_BASE_PATH, RightPanelConstant, MiddlePanelConstant, StringConstants, ExternalAppView ,ErrorCode} from './constants';
import { addClass, removeClass, setObjectInStorage, renderScript, renderCSS, redirectURL, isIpad, isMobile ,isDesktop, isTablet } from "../../common/util";
import ManageProfile from "../Header/ManageProfile";
import ErrorScreen from "../../ErrorScreens";
import Cookies from 'js-cookie'
import { SeturlHash } from './utils';
import * as CommonUtil from '../../common/util';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useLegacyHistory } from '../../router/hooks';
import { useClaimFocus } from '../../utils/useClaimFocus';

const WorkkardDetail = (props) => {
  const dispatch = useDispatch();
  const { isModuleEnabled } = useModules();
  const { location, history } = useLegacyHistory();
  // Tell bifrost which claim this tab is showing, so its events arrive even for
  // a user who is only looking at it. Read from the URL rather than the store:
  // the claim is named there before its data has loaded.
  useClaimFocus(queryString.parse(location?.search)?.cId);
  const isLoading = useSelector(state => state.isLoading);
  const toast = useSelector(state => state.toast);
  const dialogueBox = useSelector(state => state.dialogueBox);
  const rightPopUpComponent = useSelector(state => state.rightPopUpComponent);
  const panelVisibility = useSelector(state => state.workkardDetail.panelVisibility);
  const startTour = useSelector(state => state.workkardDetail.startTour);
  const resolution = useSelector(state => state.workkardDetail.resolution);
  const appError = useSelector(state => state.appError);
  const workkardId = useSelector(state => state.workkardDetail.workkardDetail.Id);
  const currentActivity = useSelector(state => state.workkardDetail.activityListing.currentActivity);
  const loadedActivityId = useSelector(state => state.workkardDetail.activityDetail?.activityId);
  const sessionContext = useSelector(selectSessionContextOidc);
  const userView = sessionContext?.userView;
  const userPermission = userView?.permissions;
  const canAccessExternalApp =
    (userPermission?.can_access_financials && isModuleEnabled("workkards.financial"))
    || (userPermission?.can_request_for_letter && isModuleEnabled("workkards.letters"))
    || (userPermission?.can_access_review_system && isModuleEnabled("workkards.review_system"));

  const [showWorkkardDetailPopUp, setShowWorkkardDetailPopUp] = React.useState(false);
  const [showAssociatedWorkkardDetailPopUp, setShowAssociatedWorkkardDetailPopUp] = React.useState(false);
  const [showChangeOwnerBlock, setShowChangeOwnerBlock] = React.useState(false);
  const [externalDistLoaded, setExternalDistLoaded] = React.useState(false);
  const [externalVendorLoaded, setExternalVendorLoaded] = React.useState(false);
  const [showWrkdetailInMobileView, setShowWrkdetailInMobileView] = React.useState(false);
  const [showCobmineViewfilter, setShowCobmineViewfilter] = React.useState(false);
  const [isFilterApplied, setIsFilterApplied] = React.useState(false);

  const prevDialogueBoxFlagRef = React.useRef(dialogueBox.flag);
  const prevPanelVisibilityRef = React.useRef(panelVisibility);
  const prevStartTourRef = React.useRef(startTour);
  const prevAppErrorRef = React.useRef(appError);
  const prevRightPopUpRef = React.useRef(rightPopUpComponent);
  const prevSessionContextRef = React.useRef(sessionContext);
  // What has been projected into the url's ?combined so far. The url itself cannot
  // be the guard: the router applies a navigation a microtask after this render's
  // closure was built, so reading it back would let one view change write twice.
  // null until the first run, which seeds it from the url.
  const projectedCombinedRef = React.useRef(null);
  // Read inside the url -> redux effect, which must stay keyed on location alone.
  const panelVisibilityRef = React.useRef(panelVisibility);
  panelVisibilityRef.current = panelVisibility;

  const onDialogueClose = () => {
    dispatch(showDialogueBox({
      flag: false,
      title: null,
      dialogueBoxComponent: null
    }));
  };

  const onNotificationClick = (type) => {
    let body = document.querySelector("body");
    if (type === "open") {
      dispatch(setPanelVisibility({ isNotificationPanelOpen: true }));
      if (!panelVisibility.isRightVisible) {
        addClass(body, 'openNotification');
      }
    } else {
      removeClass(body, 'au_fixed_right');
      removeClass(body, 'openNotification');
      dispatch(setPanelVisibility({ isNotificationPanelOpen: false }));
    }
  };

  const onNotificationClickRef = React.useRef(onNotificationClick);
  onNotificationClickRef.current = onNotificationClick;

  const renderExternalApp = (subheader) => {
    if (ExternalAppView[subheader]) {
      SeturlHash(false, null, null, history, ExternalAppView[subheader]);
      projectedCombinedRef.current = false;
      if (!panelVisibility.isVisibleExternalApp) {
        dispatch(setPanelVisibility({
          isLeftVisible: false,
          isMiddleVisible: false,
          isVisibleExternalApp: true
        }));
      }
    }
  };

  React.useEffect(() => {
    const finScript = document.querySelector('script[data-id="infinity-financial.js"]');
    const letterScript = document.querySelector('script[data-id="infinity-letter_request.js"]');
    const reviewScript = document.querySelector('script[data-id="infinity-review.js"]');

    if (finScript !== null || letterScript !== null || reviewScript !== null) {
      setExternalVendorLoaded(true);
      setExternalDistLoaded(true);
    }

    document.body.classList.add("detailLayout");
    const QuerySearchValues = queryString.parse(location?.search);
    const QueryHashValues = window.location.hash;
    const QuerySearchValuesKeys = Object.keys(QuerySearchValues);

    if (QuerySearchValuesKeys.length > 0 && !QuerySearchValuesKeys.includes('cId')) {
      if (WORKKARD_ID != null) { QuerySearchValues['cId'] = WORKKARD_ID; }
    }
    if (QuerySearchValues) {
      // An activity-only link (/gad?actId=)
      const isActivityOnlyLink = QuerySearchValuesKeys.includes('actId') && !QuerySearchValues['cId'];
      if (isActivityOnlyLink) {
        const actId = QuerySearchValues['actId'];
        dispatch(getActivityDetail({
          actId,
          callback: (activity) => {
            if (!activity?.workkardId) return;
            SeturlHash(false, actId, activity.workkardId, history, null, false, true);
            dispatch(setActivityId({ id: actId }));
            dispatch(getWorkkardDetailMasterData({ ...QuerySearchValues, cId: activity.workkardId }));
          },
        }));
      }
      if (QuerySearchValuesKeys.includes('actId')) {
        if (!isActivityOnlyLink) dispatch(setActivityId({ id: QuerySearchValues['actId'] }));
        if (QueryHashValues) {
          let payload = {
            type: QueryHashValues.charAt(1) === 'a' ? MiddlePanelConstant.ActivityType : MiddlePanelConstant.WorkkardType,
            cId: QuerySearchValues['cId'],
            actId: QuerySearchValues['actId'],
            skip: 0, take: 10, sortBy: "0", reviewFilter: '0',
          };
          switch (QueryHashValues.charAt(2)) {
            case 'n': dispatch(resetMiddlePanel({ type: 'notes', value: payload.type })); break;
            case 'f': dispatch(resetMiddlePanel({ type: 'files', value: payload.type })); break;
            case 'd': dispatch(resetMiddlePanel({ type: 'diaries', value: payload.type })); break;
            case 'l': dispatch(resetMiddlePanel({ type: 'logs', value: payload.type })); break;
            case 'p': dispatch(resetMiddlePanel({ type: 'parties', value: payload.type })); break;
          }
        }
      }
      if (QuerySearchValuesKeys.includes('combined')) {
        const isCombinedUrl = String(QuerySearchValues['combined']).split('#')[0] === "true";
        dispatch(toggleView(isCombinedUrl ? RightPanelConstant.CombinedViewText : RightPanelConstant.NormalView));
      }
      if (QuerySearchValuesKeys.includes('aswk')) {
        dispatch(toggleView(QuerySearchValues['aswk'] === "true" ? setShowAssociatedWorkkardDetailPopUp(true) : RightPanelConstant.NormalView));
      }
      if (QueryHashValues === "#financial") { dispatch(toggleView(RightPanelConstant.FinancialView.toLowerCase())); }
      if (QueryHashValues === "#letter") { dispatch(toggleView(RightPanelConstant.LettersView.toLowerCase())); }
      if (QueryHashValues === "#review") { dispatch(toggleView(RightPanelConstant.ReviewsView.toLowerCase())); }
      if (!isActivityOnlyLink) dispatch(getWorkkardDetailMasterData(QuerySearchValues));
    }
    dispatch(getUserTourStatusAction());

    return () => {
      window.removeEventListener('auPanelClicked', (e) => onNotificationClickRef.current(e));
      // Creating an activity leaves this page for a sibling route and comes back,
      // so without this the remount inherits the previous visit's activity list
      // and detail -- and auto-selects the activity the user has just left.
      dispatch(resetWorkkardDetail());
    };
  }, []);

  React.useEffect(() => {
    if (prevDialogueBoxFlagRef.current && dialogueBox.flag === false) {
      onDialogueClose();
    }
    prevDialogueBoxFlagRef.current = dialogueBox.flag;
  }, [dialogueBox.flag]);

  // Url -> redux sync. The mount effect above seeds the first actId and the left panel
  // auto-selects the latest activity, so this only needs to handle later url changes -
  // i.e. browser back/forward - which nothing else listens for.
  const hasSyncedActIdRef = React.useRef(false);
  React.useEffect(() => {
    if (!hasSyncedActIdRef.current) {
      hasSyncedActIdRef.current = true;
      return;
    }
    const { actId, combined } = queryString.parse(location?.search) || {};
    if (actId && Number(actId) !== currentActivity) {
      dispatch(setActivityId({ id: actId }));
    }
    const visibility = panelVisibilityRef.current;
    const view = visibility.toggleView;
    if (view === RightPanelConstant.NormalView || view === RightPanelConstant.CombinedViewText) {
      const urlSaysCombined = typeof combined !== 'undefined' && String(combined).split('#')[0] === 'true';
      if (urlSaysCombined !== (view === RightPanelConstant.CombinedViewText)) {
        projectedCombinedRef.current = urlSaysCombined;
        dispatch(setPanelVisibility({
          isLeftVisible: visibility.isNoteVisible ? false : true,
          isMiddleVisible: true,
          isVisibleExternalApp: false,
          toggleView: urlSaysCombined ? RightPanelConstant.CombinedViewText : RightPanelConstant.NormalView,
        }));
      }
    }
  }, [location?.search]);

  React.useEffect(() => {
    if (!currentActivity || currentActivity == loadedActivityId) return;
    dispatch(getActivityDetail({ actId: currentActivity }));
  }, [currentActivity, loadedActivityId]);

  React.useEffect(() => {
    const QuerySearchValues = queryString.parse(location?.search);
    if (QuerySearchValues.cId && workkardId && QuerySearchValues.cId != workkardId) {
      dispatch(resetWorkkardDetail());
      dispatch(getWorkkardDetailMasterData(QuerySearchValues));
    }
  }, [workkardId, location?.search]);

  React.useEffect(() => {
    const view = panelVisibility.toggleView;
    // financial, letter and review own their own url through renderExternalApp
    if (view !== RightPanelConstant.NormalView && view !== RightPanelConstant.CombinedViewText) {
      return;
    }
    const shouldBeCombined = view === RightPanelConstant.CombinedViewText;
    const { combined } = queryString.parse(location?.search) || {};
    const urlSaysCombined = typeof combined !== 'undefined' && String(combined).split('#')[0] === 'true';

    if (projectedCombinedRef.current === null) {
      projectedCombinedRef.current = urlSaysCombined;
      return;
    }
    if (projectedCombinedRef.current === shouldBeCombined) {
      return;
    }
    projectedCombinedRef.current = shouldBeCombined;
    if (shouldBeCombined) {
      SeturlHash(true, null, workkardId, history, window.location.hash === '#profile' ? '#profile' : null);
    } else {
      SeturlHash(false, currentActivity || null, workkardId, history);
    }
  }, [panelVisibility.toggleView]);

  React.useEffect(() => {
    try {
      const finScript = document.querySelector('script[data-id="infinity-financial.js"]');
      if (finScript === null && sessionContext && userView && userPermission?.can_access_financials) {
        renderCSS("infinity-financial");
        renderScript("infinity-financial").then(() => { setExternalDistLoaded(true); });
        renderScript("vendor-financials").then(() => { setExternalVendorLoaded(true); });
      }
      const reviewScript = document.querySelector('script[data-id="infinity-review.js"]');
      if (reviewScript === null && sessionContext && userView && userPermission?.can_access_review_system) {
        renderCSS("infinity-review");
        renderScript("infinity-review").then(() => { setExternalDistLoaded(true); });
        renderScript("vendor-review").then(() => { setExternalVendorLoaded(true); });
      }
      const letterScript = document.querySelector('script[data-id="infinity-letter_request.js"]');
      if (letterScript === null && sessionContext && userView && userPermission?.can_request_for_letter) {
        renderCSS("infinity-letter_request");
        renderScript("infinity-letter_request").then(() => { setExternalDistLoaded(true); });
        renderScript("vendor-letter_request").then(() => { setExternalVendorLoaded(true); });
      }
    } catch (error) {
      console.error('Failed to load external vendor scripts (check StaticFileRootUrl env config):', error);
    }
    if (sessionContext && sessionContext.OrganizationView && sessionContext.showPopupToast) {
      dispatch(showDialogueBox({
        flag: true,
        component: <PopoverToast
          OrganizationName={sessionContext.OrganizationView.OrganizationName}
          OrganizationImage={sessionContext.OrganizationView.ProfileFullImage}
          onClose={onDialogueClose}
        />,
        overlayClassName: "modal animated faster fadeIn",
        contentClassName: "modalContent animated faster fadeInUpx2 small",
        shouldCloseOnOverlayClick: true
      }));
      setObjectInStorage("isDiffrentUser", false);
      dispatch(hidePopupToast({ showPopupToast: false }));
    }
    prevSessionContextRef.current = sessionContext;
  }, [sessionContext]);

  React.useEffect(() => {
    if (appError.status && appError.status !== prevAppErrorRef.current.status) {
      if (appError.status == 105) {
        window.location?.reload();
      } else if (appError.isErrorScreen) {
        dispatch(showDialogueBox({
          flag: true,
          component: <ErrorScreen status={appError.status} history={history} />,
          overlayClassName: "modal animated faster fadeIn",
          contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
          shouldCloseOnOverlayClick: true
        }));
      }
    }
    prevAppErrorRef.current = appError;
  }, [appError]);

  React.useEffect(() => {
    if (prevPanelVisibilityRef.current.isNoteVisible != panelVisibility.isNoteVisible && window.innerWidth > 2000) {
      dispatch(resolutionBasedClass({ masterResolution: panelVisibility.isNoteVisible ? 'noteExpandView' : '' }));
    }
    prevPanelVisibilityRef.current = panelVisibility;
  }, [panelVisibility]);

  React.useEffect(() => {
    if (rightPopUpComponent.flag != prevRightPopUpRef.current.flag) {
      onNotificationClick(rightPopUpComponent.type || "");
    }
    prevRightPopUpRef.current = rightPopUpComponent;
  }, [rightPopUpComponent]);

  React.useEffect(() => {
    renderExternalApp(panelVisibility.toggleView.toLowerCase());
  }, [panelVisibility.toggleView]);

  React.useEffect(() => {
    setShowWrkdetailInMobileView(panelVisibility.showWkInMobileView);
  }, [panelVisibility.showWkInMobileView]);

  React.useEffect(() => {
    if (startTour.isNewUser && prevStartTourRef.current.isNewUser !== startTour.isNewUser) {
      dispatch(showDialogueBox({
        flag: true,
        component: (
          <div className="startTourPopUp">
            <div className="modalBody">
              <a href="javascript:void(0)" onClick={onDialogueClose} className="closeTourPopUp"><Icon name="close" className="icon" /></a>
              <img src={IMAGE_BASE_PATH + "/images/onBoarding.svg"} />
              <h1>Welcome {userView ? userView.firstName : ''}</h1>
              <p>To help you get most out of ClaimColony, we have added a quick tour.</p>
              <button className="startTour" onClick={() => {
                dispatch(startTourAction(true));
                onDialogueClose();
              }}>Start tour</button>
            </div>
          </div>
        ),
        overlayClassName: "modal animated faster fadeIn",
        contentClassName: "modalContent animated faster fadeInUpx2 medium",
        shouldCloseOnOverlayClick: true
      }));
    }
    prevStartTourRef.current = startTour;
  }, [startTour]);

  const handleRightPanelPopUpsOnMobileDevices = (data) => {
    if (data.includes(RightPanelConstant.WorkkardDetailText)) {
      setShowWorkkardDetailPopUp(true);
    } else if (data.includes(RightPanelConstant.AssociatedWorkkardsText)) {
      setShowAssociatedWorkkardDetailPopUp(true);
    }
  };

  const toggleChangeOwnerBlock = () => {
    setShowChangeOwnerBlock(prev => {
      const next = !prev;
      if (next) { $('body').addClass("changeOwnerPopupMobile"); }
      else { $('body').removeClass("changeOwnerPopupMobile"); }
      return next;
    });
  };

  const closeToast = (type) => {
    dispatch(hideToast());
    if (type == "timezone") {
      let domainName = $('#siteUrl').val();
      Cookies.set('Show_Is_Toast_Displayed', 'true', { domain: domainName });
    }
  };

  const onViewToastClick = (type, cid, actid, hash) => {
    if (type == "timezone") {
      dispatch(showDialogueBox({
        flag: true,
        component: <ManageProfile onClose={() => { onDialogueClose(); }} />,
        overlayClassName: "modal animated faster fadeIn",
        contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
        shouldCloseOnOverlayClick: true
      }));
      let redirectPath = { hash: `${hash}` };
      closeToast(type);
      redirectURL(history, { ...history.location, ...redirectPath });
    } else {
      const QuerySearchValues = queryString.parse(location?.search);
      const QuerySearchValuesKeys = Object.keys(QuerySearchValues);
      if (QuerySearchValuesKeys.includes('combined')) {
        dispatch(toggleView(RightPanelConstant.NormalView));
      }
      let combinedViewElement = document.querySelector("a[type='combined view']");
      let activitiesElement = document.querySelector("a[type='activities']");
      removeClass(combinedViewElement, "active");
      addClass(activitiesElement, "active");
      if (actid != null && actid != 0) { dispatch(setActivityId({ id: actid })); }
      dispatch(resetMiddlePanel({ type: 'notes', value: type == StringConstants.activity ? StringConstants.activity : StringConstants.workkard }));
      dispatch(fetchMiddlePanelData({ activeTab: 0 }));
      dispatch(getWorkkardDetailMasterData({ cId: cid, actId: actid, doNotUpdateActivityListing: true, updateActivityDetail: type == StringConstants.activity ? true : false }));
      // let redirectPath = { hash: `${hash}` };
      // CommonUtil.redirectURL(history, { ...history.location, ...redirectPath });
      projectedCombinedRef.current = false;
      if (actid != null && actid != 0) {
        SeturlHash(false, actid, cid, history, hash);
      } else {
        SeturlHash(false, null, null, history, hash);
      }
      dispatch(hideToast());
    }
    onWrkkrdDetailMblViewClick();
  };

  const closeWorkkardDetailPopUp = () => { setShowWorkkardDetailPopUp(false); };
  const closeAssociatedWorkkardDetailPopUp = () => { setShowAssociatedWorkkardDetailPopUp(false); };

  const subHeaderClicked = (evt) => {
    const viewType = evt.detail.type;
    switch (viewType.toLowerCase()) {
      case RightPanelConstant.NormalView.toLowerCase():
        return dispatch(setPanelVisibility({ isLeftVisible: panelVisibility.isNoteVisible ? false : true, isMiddleVisible: true, isVisibleExternalApp: false, toggleView: RightPanelConstant.NormalView }));
      case RightPanelConstant.CombinedViewText.toLowerCase():
        return dispatch(setPanelVisibility({ isLeftVisible: panelVisibility.isNoteVisible ? false : true, isMiddleVisible: true, isVisibleExternalApp: false, toggleView: RightPanelConstant.CombinedViewText }));
      case RightPanelConstant.FinancialView.toLowerCase():
      case RightPanelConstant.LettersView.toLowerCase():
      case RightPanelConstant.ReviewsView.toLowerCase():
        return dispatch(toggleView(viewType.toLowerCase()));
      default: return null;
    }
  };

  const onWrkkrdDetailMblViewClick = () => {
    setShowWrkdetailInMobileView(false);
    dispatch(setPanelVisibility({ showWkInMobileView: false }));
  };

  const oncbFilterView = () => { setShowCobmineViewfilter(prev => !prev); };

  const handletoggler = () => {
    dispatch(setPanelVisibility({ isRightPanelExpand: false }));
    document.body.classList.add('centerLayout');
  };

  const setfilter = (flag) => { setIsFilterApplied(flag); };

  const showIpadView = isIpad() && panelVisibility.isRightPanelExpand;
  const toggler = () => (
    <button className="tabSwitcher alignCenter animated delay-5ms superFasterSmall fadeInLeft" onClick={handletoggler}>
      <span><Icon name="chev" className="icon shift__top__1 arrow" /></span>
    </button>
  );
  const showInPopUp = isMobile() && (showCobmineViewfilter || showWrkdetailInMobileView);
  const className = showInPopUp
    ? `detailPage detailPageMob ${isDesktop() && 'animated faster'} ${resolution.masterResolution}`
    : `detailPage ${resolution.masterResolution}`;
  const isMob = isMobile();

  return (
    <>
      {showInPopUp ? <div className="transparentOverlay"></div> : null}
      <div className={className}>
        {
          sessionContext && userView && !isMob ?
            <>
              {panelVisibility.isLeftVisible && !showIpadView && <LeftPanelContainer history={history} />}
              {showIpadView && toggler()}
              {panelVisibility.isMiddleVisible && <MiddlePanelContainer history={history} handleRightPanelPopUpsOnMobileDevices={handleRightPanelPopUpsOnMobileDevices} toggleChangeOwnerBlock={toggleChangeOwnerBlock} />}
              {externalDistLoaded && externalVendorLoaded && panelVisibility.isVisibleExternalApp && sessionContext && userView && canAccessExternalApp && <ExternalAppContainer view={ExternalAppView[panelVisibility.toggleView]} />}
              {panelVisibility.isNoteVisible && <NotePanelContainer />}
              {panelVisibility.isRightVisible &&
                <RightPanelContainer
                  location={location}
                  history={history}
                  enableWorkkardDetailPopUp={showWorkkardDetailPopUp}
                  enableAssociatedWorkkardDetailPopUp={showAssociatedWorkkardDetailPopUp}
                  closeWorkkardDetailPopUp={closeWorkkardDetailPopUp}
                  closeAssociatedWorkkardDetailPopUp={closeAssociatedWorkkardDetailPopUp}
                  showChangeOwnerBlock={showChangeOwnerBlock}
                  toggleChangeOwnerBlock={toggleChangeOwnerBlock}
                />
              }
            </>
            :
            <>
              {!showWrkdetailInMobileView && !showCobmineViewfilter ?
                <div>
                  <div className="pageViewBlock leftSide" onClick={() => oncbFilterView()}>
                    {panelVisibility.toggleView.includes("Combined") && !showCobmineViewfilter && isMobile() ?
                      <a className={isFilterApplied ? "pageViewBlock combinedViewFilter active" : "combinedViewFilter"}>
                        <span className="filterCc"></span><Icon name="filter" className="icon" /></a> : null}
                  </div>
                </div>
                : !isMobile() && <div className="pageViewBlock leftSide" onClick={() => onWrkkrdDetailMblViewClick('a')}> {panelVisibility.toggleView.includes("Combined") ? <a className="combinedViewFilter active"><span className="filterCc"></span><Icon name="filter" className="icon" /></a> : <a className="activityInformation">A</a>} </div>
              }
              {panelVisibility.isLeftVisible && !showIpadView && !showWrkdetailInMobileView &&
                <LeftPanelContainer history={history} showInPopUp={showInPopUp && showCobmineViewfilter} closeCbFilter={oncbFilterView} setfilter={setfilter} />}
              {(!showWrkdetailInMobileView || !isTablet()) &&
                <MiddlePanelContainer history={history} handleRightPanelPopUpsOnMobileDevices={handleRightPanelPopUpsOnMobileDevices} toggleChangeOwnerBlock={toggleChangeOwnerBlock} showFilter={showCobmineViewfilter} />}
              {externalDistLoaded && externalVendorLoaded && panelVisibility.isVisibleExternalApp && sessionContext && userView && canAccessExternalApp && <ExternalAppContainer view={ExternalAppView[panelVisibility.toggleView]} />}
              {panelVisibility.isNoteVisible && <NotePanelContainer />}
              {showWrkdetailInMobileView && !showCobmineViewfilter &&
                <RightPanelContainer
                  location={location}
                  history={history}
                  enableWorkkardDetailPopUp={showWorkkardDetailPopUp}
                  enableAssociatedWorkkardDetailPopUp={showAssociatedWorkkardDetailPopUp}
                  closeWorkkardDetailPopUp={closeWorkkardDetailPopUp}
                  closeAssociatedWorkkardDetailPopUp={closeAssociatedWorkkardDetailPopUp}
                  showChangeOwnerBlock={showChangeOwnerBlock}
                  toggleChangeOwnerBlock={toggleChangeOwnerBlock}
                  closeMblPopUp={onWrkkrdDetailMblViewClick}
                  showPopUp={showInPopUp && showWrkdetailInMobileView}
                />
              }
            </>
        }

        {
          toast.show
          && toast.entityType != "publicapi" &&
          <Toast
            message={toast.message}
            type={toast.type}
            delayTime={toast.delayTime}
            closeToast={() => closeToast(toast.entityType)}
            show={toast.show}
            entityType={toast.entityType}
            cId={toast.cId}
            actId={toast.actId}
            onViewToastClick={onViewToastClick}
            showActions={toast.showActions}
            isCloseIcon={toast.isCloseIcon}
            autoClose={toast.autoClose}
            iconType={toast.iconType}
          >
          </Toast>
        }
        {/* <AppLoader isLoading={isLoading} />      */}
        {/* <AppTour startTour={startTour.isStartTour}/> */}
      </div>
    </>
  );
};

export default WorkkardDetail;
